import { Button, FilesPreview, Tag } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import type { DuplicateReceipt } from '../../types'
import { ReceiptInfoField } from '../ReceiptInfoField/ReceiptInfoField'
import * as Styled from './styles'

interface ReceiptPanelProps {
  receipt: DuplicateReceipt
  isIncoming: boolean
  onOpenDocument?: (url: string) => void
}

export const ReceiptPanel = ({ receipt, isIncoming, onOpenDocument }: ReceiptPanelProps) => {
  const { t } = useTranslation()

  return (
    <Styled.ReceiptPanelWrapper>
      <Styled.ReceiptPreviewWrapper>
        <FilesPreview
          className="receipt-preview"
          files={[{ src: receipt.imageUrl }]}
          fitToHeight
          isFloatingActionsView
          floatingActionsPanelPosition="16px"
          zoomable
          withRotate
        />
      </Styled.ReceiptPreviewWrapper>
      <Styled.ReceiptInfoWrapper>
        <Styled.TagWrapper>
          {isIncoming ? (
            <Tag type="subtle" color="yellow">
              {t('receipts.receipts_list.type.duplicate')}
            </Tag>
          ) : (
            <Tag type="subtle" color="neutral">
              {t('receipts.duplicate_review_modal.tag.existing')}
            </Tag>
          )}
        </Styled.TagWrapper>
        <ReceiptInfoField label={t('attachment_preview_modal.details.filename_label')} value={receipt.imageName} />
        <ReceiptInfoField label={t('attachment_preview_modal.details.vendor_label')} value={receipt.supplier} />
        <ReceiptInfoField label={t('attachment_preview_modal.details.receipt_date_label')} value={receipt.date} />
        <ReceiptInfoField label={t('attachment_preview_modal.details.upload_date_label')} value={receipt.uploadDate} />
        <ReceiptInfoField label={t('attachment_preview_modal.details.due_date_label')} value={receipt.dueDate} />
        <ReceiptInfoField label={t('attachment_preview_modal.details.description_label')} value={receipt.description} />
        <ReceiptInfoField label={t('attachment_preview_modal.details.tax_rate_label')} value={receipt.taxRate} />
        <ReceiptInfoField label={t('attachment_preview_modal.details.incl_vat_label')} value={receipt.inclVat} />

        {!isIncoming && receipt.linkToFile && onOpenDocument && (
          <Styled.OpenDocumentWrapper>
            <Button
              iconRight="squareArrowOutUpRight"
              type="button"
              variant="text"
              onClick={() => onOpenDocument(receipt.linkToFile ?? '')}
            >
              {t('receipts.duplicate_review_modal.open_document')}
            </Button>
          </Styled.OpenDocumentWrapper>
        )}
      </Styled.ReceiptInfoWrapper>
    </Styled.ReceiptPanelWrapper>
  )
}
